import React from 'react';
import PropTypes from 'prop-types';

import { TableHead as MUITableHead } from '@mui/material';

export const TableHead = props => <MUITableHead {...props} />;

TableHead.propTypes = {
  classes: PropTypes.object,
  component: PropTypes.elementType
};

export default TableHead;
